// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xME1","placeholdersHeader":"styles_placeholdersHeader__2Sp72","editorStyle":"styles_editorStyle__3X9r5","placeholdersBox":"styles_placeholdersBox__Co4yH"};